import React from 'react';
import SelectComponent, { Value } from '.';
import { Props } from './SelectBody';
import { FieldRenderProps } from 'react-final-form';

export default function FormSelectWrapper<T extends Value>(
  props: FieldRenderProps<T, HTMLInputElement> & Props<T>,
) {
  const { input, meta, ...rest } = props;
  return <SelectComponent {...input} {...rest} />;
}
